import { useTranslation } from 'react-i18next';
import BlurText from '../../effects/BlurText/BlurText';
import Grain from '../../effects/Grain/Grain';
import PillLink from '../../ui/PillLink/PillLink';
import moonTall from '../../../assets/img/hero/moon-tall-1080.webp';
import moonWide from '../../../assets/img/hero/moon-wide-1440.webp';
import moonWideLarge from '../../../assets/img/hero/moon-wide-2400.webp';
import { CONTACT_PATH } from '../../../data/navigation';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './HomeHero.module.css';

const PORTRAIT_QUERY = '(max-aspect-ratio: 4/5)';

export default function HomeHero() {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();

    return (
        <section className={styles.hero} data-theme="dark" aria-labelledby="hero-title">
            <picture className={styles.media}>
                <source media={PORTRAIT_QUERY} srcSet={moonTall} />
                <source srcSet={`${moonWide} 1440w, ${moonWideLarge} 2400w`} sizes="100vw" />
                <img src={moonWide} alt="" width={1440} height={810} fetchPriority="high" decoding="async" className={styles.image} />
            </picture>
            <Grain />

            <div className={`page-inner ${styles.content}`}>
                <BlurText as="h1" id="hero-title" text={t('home.hero.title')} className={styles.title} stepMs={140} />
                <div className={styles.row}>
                    <p className={styles.lead}>{t('home.hero.lead')}</p>
                    <div className={styles.actions}>
                        <PillLink href={localizedPath(CONTACT_PATH)} size="large" icon="arrowRight">{t('home.hero.primaryAction')}</PillLink>
                        <PillLink href={localizedPath('/work')} variant="glass" size="large">{t('home.hero.secondaryAction')}</PillLink>
                    </div>
                </div>
            </div>
        </section>
    );
}
